import React, { useState }  from 'react'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal';
import { useEffect } from 'react';


export default function RegisterForm() {
    const [form, setForm] = useState({ Teamname: '', PlayerOneFirstName: '', PlayerOneLastName: '', PlayerOneEmail: '', PlayerOneMobile: '', PlayerTwoFirstName: '', PlayerTwoLastName: '', PlayerTwoEmail: '', PlayerTwoMobile: '' });
    const [status, setStatus] = useState(null);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    useEffect(() => {
        if (status) {
            handleShow();
        }
    }, [status]);

    const handleSubmit = async (e) => {
        console.log("submit func gecalled")
        e.preventDefault();
        setStatus("Submitting...");

        try {
            const response = await fetch('https://steadfast-festival-dd089030c4.strapiapp.com/api/registrations', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ data: form }),
            });

            if (!response.ok) throw new Error("Failed to submit");

            setStatus("Anmeldung erflogreich!");
            setForm({ Teamname: '', PlayerOneFirstName: '', PlayerOneLastName: '', PlayerOneEmail: '', PlayerOneMobile: '', PlayerTwoFirstName: '', PlayerTwoLastName: '', PlayerTwoEmail: '', PlayerTwoMobile: '' });
        } catch (error) {
            console.error(error);
            setStatus("Error sending message.");
        }
    };


    return(
        <div>
            <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3" controlId="Teamname">
                    <Form.Label>Teamname</Form.Label>
                    <Form.Control type="text" placeholder="Teamname" name="Teamname" value={form.Teamname} onChange={handleChange} required/>
                </Form.Group>

                <Form.Group className="mb-3" controlId="PlayerOneFirstName">
                    <Form.Label>Spieler*in 1 Vorname</Form.Label>
                    <Form.Control type="text" placeholder="Spieler*in 1 Vorname" name="PlayerOneFirstName" value={form.PlayerOneFirstName} onChange={handleChange} required/>
                </Form.Group>

                <Form.Group className="mb-3" controlId="PlayerOneLastName">
                    <Form.Label>Spieler*in 1 Nachname</Form.Label>
                    <Form.Control type="text" placeholder="Spieler*in 1 Nachname" name="PlayerOneLastName" value={form.PlayerOneLastName} onChange={handleChange} required/>
                </Form.Group>

                <Form.Group className="mb-3" controlId="PlayerOneEmail">
                    <Form.Label>Spieler*in 1 E-Mail</Form.Label>
                    <Form.Control type="text" placeholder="Spieler*in 1 E-Mail" name="PlayerOneEmail" value={form.PlayerOneEmail} onChange={handleChange} required/>
                </Form.Group>

                <Form.Group className="mb-3" controlId="PlayerOneMobile">
                    <Form.Label>Spieler*in 1 Natel</Form.Label>
                    <Form.Control type="text" placeholder="Ohne Leerzeichen und ohne Pluszeichen etc. bsp: 0791234567" name="PlayerOneMobile" value={form.PlayerOneMobile} onChange={handleChange} required/>
                </Form.Group>

                <Form.Group className="mb-3" controlId="PlayerTwoFirstName">
                    <Form.Label>Spieler*in 2 Vorname</Form.Label>
                    <Form.Control type="text" placeholder="Spieler*in 2 Vorname" name="PlayerTwoFirstName" value={form.PlayerTwoFirstName} onChange={handleChange} required/>
                </Form.Group>

                <Form.Group className="mb-3" controlId="PlayerTwoLastName">
                    <Form.Label>Spieler*in 2 Nachname</Form.Label>
                    <Form.Control type="text" placeholder="Spieler*in 2 Nachname" name="PlayerTwoLastName" value={form.PlayerTwoLastName} onChange={handleChange} required/>
                </Form.Group>

                <Form.Group className="mb-3" controlId="PlayerTwoEmail">
                    <Form.Label>Spieler*in 2 E-Mail</Form.Label>
                    <Form.Control type="text" placeholder="Spieler*in 2 E-Mail" name="PlayerTwoEmail" value={form.PlayerTwoEmail} onChange={handleChange} required/>
                </Form.Group>

                <Form.Group className="mb-3" controlId="PlayerTwoMobile">
                    <Form.Label>Spieler*in 2 Natel</Form.Label>
                    <Form.Control type="text" placeholder="Ohne Leerzeichen und ohne Pluszeichen etc. bsp: 0791234567" name="PlayerTwoMobile" value={form.PlayerTwoMobile} onChange={handleChange} required/>
                </Form.Group>

                <Button variant="primary" type="submit">
                    Anmelden
                </Button>

                <Modal show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Info</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>{status}</Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={handleClose}>
                            Schliessen
                        </Button>
                    </Modal.Footer>
                </Modal>
            </Form>

        </div>
    )

}